(function($, undefined) {
	'use strict';
    
    var SUBMITTING_FORM = false;

	var updateBgPosLabel = function() {
		var t = $(this);
		var value = t.val() + "%";
		var key = t.data('key');

		var langs = $('html').attr('data-all-langs');
		updateLabelLangs(key, value, langs, function() {}, true);
	};

	var changeBgPos = function() {
		var t = $(this);
		var ctn = $('.background-img-' + t.attr('data-id'));
		var currentPosition = ctn.css('backgroundPosition');
		var value = t.val();
		var otherVal;

		// change background
		if (t.hasClass('horizontal')) {
			otherVal = currentPosition.split('% ');
			ctn.css('backgroundPosition', value + '% ' + otherVal[1]);
		} else if (t.hasClass('vertical')) {
			otherVal = currentPosition.split(' ');
			ctn.css('backgroundPosition', otherVal[0] + ' ' + value + '%');
		}
	};

	var toggleElement = function() {
		var t = $(this);
		var ctn = t.closest('.toggle-outer-ctn');
		var el = ctn.find('.element-to-toggle');

		if (!ctn.length || !el.length) {
			el = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
			ctn = t.parent();
		}

		if (t.hasClass('required-toggle')) {
			if (el.css('display') === 'block' && el.find('input, select, .form-input').hasClass('required')) {
				el.find('input.required, select.required, .form-input.required, .form-input-big-ctn.required').removeClass('required').addClass('derequired');
			} else if (el.css('display') !== 'block' && el.find('input, select, .form-input').hasClass('derequired')) {
				el.find('input.derequired, select.derequired, .form-input.derequired, .form-input-big-ctn.derequired').removeClass('derequired').addClass('required');
			}
		}

		if (t.hasClass('delete-val-toggle')) {
			el.find('input').val('');
		}

		ctn.toggleClass('open');
		el.slideToggle();
	};
	
	var settingsInputChange = function () {
		var t = $(this);
		var label = t.attr('name');
		var val = t.is(':checked').toString();

		if (t.attr('value')) {
			val = t.attr('value');
		}
		
		updateLabelLangs(label, val, 'fr,en', function () {}, true);
	};

	var submitFilterForm = function() {
        if (!SUBMITTING_FORM) {
            SUBMITTING_FORM = true;
            $(this).closest('form').submit();
        }
	};

	var scrollToAnchor = function() {
		var anchor = window.location.href.split('#')[1];

		if (anchor !== '') {
			var content = $('[data-anchor=' + anchor + ']');
			var tabCtn = content.closest('.tab-ctn');

			if (content.length) {
				if (tabCtn !== undefined && !tabCtn.hasClass('selected')) {
					var id = tabCtn.attr('data-tab');
					var fam = tabCtn.attr('data-tab-family');

					$('.tab[data-tab=' + id + '][data-tab-family=' + fam +']').trigger('click');
				}

				var target = content.offset().top - $('.site-header').height();

				$('html').animate({scrollTop: target});
				$('body').animate({scrollTop: target});
			}
		}
	};

	var moveMessagePopups = function() {
		$('.tooltip-ctn .popup.new-message-popup').each(function() {
			var clone = $(this).clone();
			$('body').append(clone);

			$(this).remove();
		});
	};

	var typeNumbersOnly = function(e) {
		var allowed = [0, 8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

		if ($(this).hasClass('phone')) {
			allowed.push(45);
		}

		if (!e.shiftKey && allowed.indexOf(e.which) !== -1) {
			return true;
		} else {
			e.preventDefault();
			return false;
		}
	};

	var submitClosestForm = function() {
		$(this).closest('form').submit();
	};

	var init = function() {
		var bgPosRange = $('.image-bg-pos');
		$('input.numbers-only').keypress(typeNumbersOnly);
		$('body').on('click', '.toggle-trigger-element', toggleElement);
		$('.toggle-settings-label-input').change(settingsInputChange);
		$('.filter-select').change(submitFilterForm);
		bgPosRange.on('change', updateBgPosLabel);
		bgPosRange.on('input', changeBgPos);
		$('.submit-on-change').change(submitClosestForm);

		if ($('button.trigger-on-load').length) {
			$('button.trigger-on-load').trigger('click');
		}

		$('.trigger-anchor').click(function() {
			setTimeout(function() {
				scrollToAnchor();
			}, 300);
		});

		if (window.location.href.indexOf('#') !== -1) {
			scrollToAnchor();
		}

		if ($('.tooltip-ctn .popup.new-message-popup').length !== 0) {
			moveMessagePopups();
		}
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

